document.querySelectorAll('.dropdown-toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
        toggle.classList.toggle('active');
        const dropdownContent = toggle.nextElementSibling;
        if (dropdownContent && dropdownContent.classList.contains('dropdown-content')) {
            dropdownContent.classList.toggle('show');
        }
    });
});

new Swiper('.featured-reviews .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 15,
  loop: true,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    500: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 1.75,
    },
    700: {
      slidesPerView: 2,
    },
    1000: {
      slidesPerView: 2,
      centeredSlides: false,
    }      
  }
});

document.querySelectorAll('.flavor-trigger').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    setTimeout(() => {
      location.reload();
    }, 150);
  });
});

// Handle Variety Pack flavor details toggle
document.addEventListener("DOMContentLoaded", function () {
  const flavorToggles = document.querySelectorAll(".flavor");
  const flavorDetails = document.querySelectorAll(".flavor-detail");

  flavorToggles.forEach(toggle => {
    toggle.addEventListener("click", function () {
      const flavorId = this.getAttribute("data-flavor");

      // Remove active class from all details
      flavorDetails.forEach(detail => {
        detail.classList.remove("active");
      });

      // Add active class to the selected detail
      const activeDetail = document.getElementById(flavorId);
      if (activeDetail) {
        activeDetail.classList.add("active");
      }
    });
  });
});